import "./App.css";
import Main from "./view/Main";

function App() {
  return (
    <div style={{ padding: '20px' }}>
      <Main />
    </div>
  );
}

export default App;
